import { Outlet, RouteObject } from "react-router-dom";
import MainLayout from "@/containers/layout/Admin";

import Loadable from "@/components/Loadable";
import { lazy } from "react";
import { RequireAdminAuth, RequireAdminOrganizationAuth } from "./Require";

const Login = Loadable(lazy(() => import("@/containers/pages/Login")));

const UserProfile = Loadable(lazy(() => import("@/containers/pages/UserProfile/Profile")));
const EditPassword = Loadable(lazy(() => import("@/containers/pages/UserProfile/EditPassword")));

const InspectionUsers = Loadable(lazy(() => import("@/containers/pages/Admin/Inspection/User/UserList")));
const AddInspectionUser = Loadable(lazy(() => import("@/containers/pages/Admin/Inspection/User/AddUser")));
const EditInspectionUser = Loadable(lazy(() => import("@/containers/pages/Admin/Inspection/User/EditUser")));

const TempWorkOrganizationList = Loadable(lazy(() => import("@/containers/pages/Admin/Inspection/TempWork/OrganizationList")));

const Organizations = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/OrganizationList")));
const AddOrganization = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/AddOrganization")));

const OrganizationUsers = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/User/UserList")));
const AddOrganizationUser = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/User/AddUser")));
const EditOrganizationUser = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/User/EditUser")));

const QuestionnaireFields = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/Questionnaire/Fields")));
const Questionnaires = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/Questionnaire/Questionnaire")));
const QuestionnaireAllPage = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/Questionnaire/Pages/AllPage")));
// const QuestionnaireSectionPage = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/Questionnaire/Pages/SectionPage")));
const QuestionnaireSubs = Loadable(lazy(() => import("@/containers/pages/Admin/Organization/Questionnaire/Organization/QuestionnaireSubList")));


const AdminRoutes: Array<RouteObject> = [
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/",
        element: (
            <RequireAdminOrganizationAuth>
                <MainLayout />
            </RequireAdminOrganizationAuth>
        ),
        children: [
            {
                path: "inspection",
                element: <RequireAdminAuth><Outlet /></RequireAdminAuth>,
                children: [
                    {
                        path: "users",
                        element: <InspectionUsers />,
                    },
                    {
                        path: "users/add",
                        element: <AddInspectionUser />,
                    },
                    {
                        path: "users/:userId/info",
                        element: <EditInspectionUser />,
                    },
                    {
                        path: "tempworker",
                        element: <Outlet />,
                        children: [
                            {
                                path: "organization",
                                element: <TempWorkOrganizationList />,
                            }
                        ]

                    }
                ]
            },
            {
                path: "organizations",
                children: [
                    {
                        path: "",
                        element: <RequireAdminAuth><Outlet /></RequireAdminAuth>,
                        children: [
                            {
                                path: "",
                                element: <Organizations />,
                            },
                            {
                                path: "add",
                                element: <AddOrganization />,
                            },
                            {
                                path: ":organizationId/users",
                                element: <Outlet />,
                                children: [
                                    {
                                        path: "",
                                        element: <OrganizationUsers />
                                    },
                                    {
                                        path: "add",
                                        element: <AddOrganizationUser />
                                    },
                                    {
                                        path: ":userId",
                                        element: <EditOrganizationUser />
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        path: "field",
                        element: <RequireAdminAuth><Outlet /></RequireAdminAuth>,
                        children: [
                            {
                                path: "",
                                element: <Organizations />,
                            }
                        ]
                    },
                    {
                        path: "questionnaires",
                        element: <Outlet />,
                        children: [
                            {
                                path: "",
                                element: <QuestionnaireFields />,
                            },
                            {
                                path: ":questionnaireId",
                                element: <Questionnaires />,
                            },
                            {
                                path: ":questionnaireId/page",
                                element: <QuestionnaireAllPage />,
                            },
                            {
                                path: ":questionnaireId/subs",
                                element: <QuestionnaireSubs />,
                            },
                            // {
                            //     path: ":questionnaireId/:section",
                            //     element: <QuestionnaireSectionPage />
                            // }
                        ]
                    },
                ]
            },

        ],
    },
    {
        path: "/user",
        element: (
            <RequireAdminOrganizationAuth>
                <MainLayout />
            </RequireAdminOrganizationAuth>
        ),
        children: [
            {
                path: "profile",
                element: <UserProfile />,
            },
            {
                path: "edit_password",
                element: <EditPassword />,
            },
        ],
    },
];

export default AdminRoutes;
